import {
    JourneyExecutionStatus,
    JOURNEY_EXECUTION_STATUS_KEYS,
    JOURNEY_EXECUTION_STATUS_LABELS,
} from "Services/Journeys.service";

export function formatDate(timestamp: number) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString(undefined, {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short",
    });
}

export function getStatusKey(status: JourneyExecutionStatus) {
    return JOURNEY_EXECUTION_STATUS_KEYS[status] ?? "default";
}

export function getStatusLabel(status: JourneyExecutionStatus) {
    return JOURNEY_EXECUTION_STATUS_LABELS[status] ?? status;
}
